import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedEvent: null, // full detail object from GET /customer_events/{event_id}/
  bookingGuests: null, // contact_info array actually submitted to /customer_events/book/
  bookingResult: null, // response.data from /customer_events/book/ (client_secret, payment_summary, ...)
  bookingConfirmation: null, // bookingResult + payment confirmation fields, set after Stripe succeeds
};

const eventBookingSlice = createSlice({
  name: "eventBooking",
  initialState,
  reducers: {
    setSelectedEvent: (state, action) => {
      state.selectedEvent = action.payload;
    },
    setEventBookingGuests: (state, action) => {
      state.bookingGuests = action.payload;
    },
    setEventBookingResult: (state, action) => {
      state.bookingResult = action.payload;
    },
    setEventBookingConfirmation: (state, action) => {
      state.bookingConfirmation = action.payload;
    },
    resetEventBooking: () => initialState,
  },
});

export const {
  setSelectedEvent,
  setEventBookingGuests,
  setEventBookingResult,
  setEventBookingConfirmation,
  resetEventBooking,
} = eventBookingSlice.actions;

export default eventBookingSlice.reducer;
